import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface AnimatedScreenProps {
  children: React.ReactNode;
  className?: string;
}
// Smooth screen transition variants
const screenVariants = {
  enter: {
    opacity: 0,
    x: 20,
    scale: 0.98
  },
  center: {
    opacity: 1,
    x: 0,
    scale: 1
  },
  exit: {
    opacity: 0,
    x: -20,
    scale: 0.98
  }
};
export function AnimatedScreen({
  children,
  className = ''
}: AnimatedScreenProps) {
  return <motion.div variants={screenVariants} initial="enter" animate="center" exit="exit" transition={{
    duration: 0.3,
    ease: [0.4, 0, 0.2, 1] // Custom easing for smooth feel
  }} className={className} data-id="element-1517">
      {children}
    </motion.div>;
}
// Staggered list animation for accounts, permissions, etc.
export const staggerContainer = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1
    }
  }
};
export const staggerItem = {
  hidden: {
    opacity: 0,
    y: 12,
    scale: 0.95
  },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.3,
      ease: [0.4, 0, 0.2, 1]
    }
  }
};
// Success celebration animation
export const successVariants = {
  hidden: {
    scale: 0,
    opacity: 0
  },
  show: {
    scale: 1,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 200,
      damping: 15,
      delay: 0.2
    }
  }
};
// Checkmark drawing animation
export const checkmarkVariants = {
  hidden: {
    pathLength: 0,
    opacity: 0
  },
  show: {
    pathLength: 1,
    opacity: 1,
    transition: {
      pathLength: {
        duration: 0.5,
        ease: 'easeInOut'
      },
      opacity: {
        duration: 0.1
      }
    }
  }
};